/**
 * Raw Materials
 */
function DietComponentsRawMaterial(json: IDietComponentsRawMaterial): IDietComponentsRawMaterialModel {
	const {
		name,
		internal_name,
		warehouse_name,
		food_category,
		is_active,
		thermal_processing_coefficient,
		mechanical_processing_coefficient,
		nutritional_parameters,
		...rest
	} = json

	return {
		...rest,
		name: LangContentToModel(name),
		internalName: internal_name,
		warehouseName: warehouse_name,
		isActive: is_active,
		foodCategory: food_category,
		thermalProcessingCoefficient: thermal_processing_coefficient,
		mechanicalProcessingCoefficient: mechanical_processing_coefficient,
		nutritionalParameters: nutritional_parameters.map(n => NutritionalParameterWithValue(n)),
	}
}

function DietComponentsSemiProductComponentPivot(
	json: IDietSemiProductComponentPivot,
): IDietSemiProductComponentPivotModel {
	const { component_type, net_weight, raw_weight, weight_after_processing, weight_unit, ...rest } = json

	return {
		...rest,
		componentType: component_type,
		netWeight: Number.isNaN(Number(net_weight)) ? 0 : Number(net_weight),
		rawWeight: Number.isNaN(Number(raw_weight)) ? 0 : Number(raw_weight),
		weightAfterProcessing: Number.isNaN(Number(weight_after_processing)) ? 0 : Number(weight_after_processing),
		weightUnit: weight_unit,
	}
}

function DietComponentsSemiProductComponent(
	json: IDietComponentsSemiProductComponent,
): IDietComponentsSemiProductComponentModel {
	const {
		name,
		internal_name,
		warehouse_name,
		food_category,
		is_active,
		pivot,
		nutritional_parameters,
		mechanical_processing_coefficient,
		thermal_processing_coefficient,
		...rest
	} = json

	return {
		...rest,
		name: LangContentToModel(name),
		internalName: internal_name,
		warehouseName: warehouse_name,
		isActive: is_active,
		foodCategory: food_category,
		pivot: DietComponentsSemiProductComponentPivot(pivot),
		nutritionalParameters: nutritional_parameters.map(n => NutritionalParameterWithValue(n)),
		mechanicalProcessingCoefficient: mechanical_processing_coefficient,
		thermalProcessingCoefficient: thermal_processing_coefficient,
	}
}

/**
 * Semi Products
 */
function DietComponentsSemiProduct(json: IDietComponentsSemiProduct): IDietComponentsSemiProductModel {
	const {
		name,
		internal_name,
		warehouse_name,
		is_active,
		standardization_factor,
		allergens,
		components,
		nutritional_parameters,
		updated_at,
		created_at,
		...rest
	} = json

	return {
		...rest,
		name: LangContentToModel(name),
		internalName: internal_name,
		warehouseName: warehouse_name,
		isActive: is_active,
		standardizationFactor: standardization_factor,
		allergens: allergens.map(a => DietAllergen(a)),
		components: components.map(c => DietComponentsSemiProductComponent(c)),
		nutritionalParameters: nutritional_parameters.map(n => NutritionalParameterWithValue(n)),
		createdAt: created_at ? new Date(created_at) : null,
		updatedAt: updated_at ? new Date(updated_at) : null,
	}
}

export const Components = (json: IDietComponents): IDietComponentsModel => {
	const { dietary_raw_materials, dietary_semi_products } = json

	return {
		dietaryRawMaterials: dietary_raw_materials.map(materials => DietComponentsRawMaterial(materials)),
		dietarySemiProducts: dietary_semi_products.map(product => DietComponentsSemiProduct(product)),
	}
}

// TODO: Check if ussefull
export const DietComponentToBase = (json: IDietComponent): IDietComponentBase => {
	const { id, type } = json

	return {
		id,
		type,
	}
}

export const DietComponentPivot = (json: IDietComponentPivot): IDietComponentPivotModel => {
	const { component_type, net_weight, raw_weight, weight_after_processing, weight_unit, group } = json

	return {
		componentType: component_type,
		group: group ?? null,
		netWeight: net_weight,
		rawWeight: raw_weight,
		weightAfterProcessing: weight_after_processing,
		weightUnit: weight_unit,
	}
}

export const DietSemiProductToSharedComponent = (data: IDietComponentsSemiProductModel): IDietComponentsShared => {
	const { ...rest } = data

	return {
		...rest,
		rawWeight: '0',
		netWeight: '0',
		weightUnit: 'g',
		weightAfterProcessing: '0',
	}
}

export const DietRawMaterialToSharedComponent = (data: IDietComponentsRawMaterialModel): IDietComponentsShared => {
	const { ...rest } = data

	return {
		...rest,
		rawWeight: '0',
		netWeight: '0',
		weightUnit: 'g',
		weightAfterProcessing: '0',
	}
}

export const DietMaterialModelToSharedComponent = (data: IDietMaterialModel): IDietComponentsShared => {
	const { ...rest } = data

	return {
		...rest,
		rawWeight: '0',
		netWeight: '0',
		weightUnit: 'g',
		weightAfterProcessing: '0',
	}
}
